'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports['default'] = {
  today: 'Oggi',
  now: 'adesso',
  backToToday: 'Torna ad oggi',
  ok: 'Ok',
  clear: 'Chiaro',
  month: 'Mese',
  year: 'Anno',
  timeSelect: 'Seleziona il tempo',
  dateSelect: 'Select date',
  monthSelect: 'Seleziona la data',
  yearSelect: 'Scegli un anno',
  decadeSelect: 'Scegli un decennio',
  yearFormat: 'YYYY',
  dateFormat: 'D/M/YYYY',
  dayFormat: 'D',
  dateTimeFormat: 'D/M/YYYY HH:mm:ss',
  monthBeforeYear: true,
  previousMonth: 'Il mese scorso (PageUp)',
  nextMonth: 'Il prossimo mese (PageDown)',
  previousYear: 'L\'anno scorso (Control + sinistra)',
  nextYear: 'L\'anno prossimo (Control + destra)',
  previousDecade: 'Ultimo decennio',
  nextDecade: 'Prossimo decennio',
  previousCentury: 'Secolo precedente',
  nextCentury: 'Prossimo secolo'
};
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./~/rc-calendar/lib/locale/it_IT.js
// module id = 1002
// module chunks = 0